/**
 * Admin UI is served on admin.noilio.com (production).
 * Set REACT_APP_ADMIN_MODE=true in .env.local to use the admin shell on any host while developing.
 */
export function isAdminHostname() {
  if (typeof window === 'undefined') return false;
  if (window.location.hostname === 'admin.noilio.com') return true;
  if (process.env.REACT_APP_ADMIN_MODE === 'true') return true;
  return false;
}
